import React from 'react';
import { Paragraph } from 'common-components/typography';
import { Radio, Row } from 'antd';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import _ from 'lodash';
import { RadioChangeEvent } from 'antd/lib/radio';

interface AssignWorkerStep11Props {
  addTimesheet: boolean | null;
  isLoading: boolean;
  onChangeAddTimesheet: (e: RadioChangeEvent) => void;
  onClose: () => void;
  onOpenEditTimesheet: () => void;
  onSubmitAssign: (a: boolean) => Promise<void>;
}

export const AssignWorkerStep11 = ({
  addTimesheet,
  isLoading,
  onChangeAddTimesheet,
  onClose,
  onOpenEditTimesheet,
  onSubmitAssign,
}: AssignWorkerStep11Props) => {
  return (
    <>
      <div className='mt-small mb'>
        <Paragraph>Do you want to add this activity record to the team members timesheet?</Paragraph>
      </div>
      <div>
        <Row>
          <Radio.Group onChange={onChangeAddTimesheet}>
            <Radio value={true}>Add hours to timesheet</Radio>
            <Radio className='mt-x-small' value={false}>
              <b>Do not</b> add hours to timesheet
            </Radio>
          </Radio.Group>
        </Row>
      </div>
      <div className='mt-medium'>
        <Row type={'flex'} justify={'end'}>
          <SecondaryButton className='mr-medium' size='large' onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            size='large'
            loading={isLoading}
            disabled={addTimesheet === null}
            onClick={addTimesheet === true ? onOpenEditTimesheet : async () => await onSubmitAssign(true)}
          >
            Finish
          </PrimaryButton>
        </Row>
      </div>
    </>
  );
};
